import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Requis pour récupérer les champs ACF du back office
    acfApi: {},
    menu: [],
    valueTunnel: {
      step1: '',
      step2: '',
      step3: '',
      // Sécificitée du tunnel actuel
      brd: '',
      surface: '',
      departement: '',
      optionsStep3: '',
      step4: '',
      step5: '',
      step5bis: '',
      step6: ''
      // Si besoin de plus d'étape, ajouter ici
    }
  },
  // Les getters pour récupérer plus proprement les valeurs
  getters: {
    // Getters pour les données de l'API WP
    getValueOfACF (state) {
      return state.acfApi
    },
    // Getters du menu
    getMenu (state) {
      return state.menu
    },
    // Getters de données obtenu par la vue
    getValueForStep1 (state) {
      return state.valueTunnel.step1
    },
    getValueForStep2 (state) {
      return state.valueTunnel.step2
    },
    getValueForStep3 (state) {
      return state.valueTunnel.step3
    },
    getValueForStep3Radio (state) {
      return state.valueTunnel.brd
    },
    getValueForStep3Options (state) {
      return state.valueTunnel.optionsStep3
    },
    getValueForStep3Surface (state) {
      return state.valueTunnel.surface
    },
    getValueForStep4 (state) {
      return state.valueTunnel.step4
    },
    getStep4Departement (state) {
      return state.valueTunnel.departement
    },
    getValueForStep5 (state) {
      return state.valueTunnel.step5
    },
    getValueForStep6 (state) {
      return state.valueTunnel.step6
    }
  },
  mutations: {
    setAllACF (state, ACF) {
      state.acfApi = ACF
      return state.acfApi
    },
    setMenu (state, menu) {
      state.menu = menu
      return state.menu
    },
    /* ****** Setters pour chaques étapes  */
    setStep1 (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.step1 = setValue
      return state.valueTunnel.step1
    },
    setStep2 (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.step2 = setValue
      return state.valueTunnel.step2
    },
    setStep3 (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.classList.add("second-el");
      }
      if (btn.classList.contains('third-el') && btn.classList.contains('fourth-el') && btn.classList.contains('first-el')) {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.step3 = setValue
      return state.valueTunnel.step3
    },
    setStep3RadioButton (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.classList.add("third-el");
      }
      if (btn.classList.contains('second-el') && btn.classList.contains('fourth-el') && btn.classList.contains('first-el')) {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.brd = setValue
      return state.valueTunnel.brd
    },
    setStep3Surface (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.classList.add("fourth-el");
      }
      if (btn.classList.contains('third-el') && btn.classList.contains('second-el') && btn.classList.contains('first-el')) {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.surface = setValue
      return state.valueTunnel.surface
    },
    setStep3Options (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.classList.add("first-el");
      }
      if (btn.classList.contains('third-el') && btn.classList.contains('fourth-el') && btn.classList.contains('second-el')) {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.optionsStep3 = setValue
      return state.valueTunnel.optionsStep3
    },
    setStep4 (state, setValue) {
      state.valueTunnel.step4 = setValue
      return state.valueTunnel.step4
    },
    setStep4Departement (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.departement = setValue
      return state.valueTunnel.departement
    },
    setStep5 (state, setValue) {
      let btn = document.querySelector('.btn-off')
      let fakebtn = document.querySelector('.fake-btn')
      let forminfo = document.querySelector('.form-info')
      if(setValue != "") {
        btn.style.display = "block";
        fakebtn.style.display = "none";
        forminfo.style.display = "none";
      }
      state.valueTunnel.step5 = setValue
      return state.valueTunnel.step5
    },
    setStep6 (state, setValue) {
      state.valueTunnel.step6 = setValue
      return state.valueTunnel.step6
    }
  },
  actions: {
    //* *************Charge tout les ACF depuis WP -> <!> EXTREMEMENT important pour toutes les étapes
    LoadAllACF ({
      commit
    }): unknown {
      // voir tuto => https://github.com/airesvsg/acf-to-rest-api
      return new Promise((resolve, reject) => {
        // Id de la page du tunnel === post WP
        const id = '3647'
        const url = new URL(document.URL)
        const call = url.origin as string + '/wp-json/acf/v3/posts/' + id
        axios.get(call)
          .then(response => {
            commit('setAllACF', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Sauvegarde le menu
    saveMenu ({
      commit
    }, menu): void {
      commit('setMenu', menu)
    },
    //* ************************************ Sauvegarde le choix utilisateur en fonction de la vue ****************** */
    saveStep1 ({
      commit
    }, stepValue): void {
      commit('setStep1', stepValue)
    },
    saveStep2 ({
      commit
    }, stepValue): void {
      commit('setStep2', stepValue)
    },
    saveStep3 ({
      commit
    }, stepValue): void {
      commit('setStep3', stepValue)
    },
    saveStep3RadioButton ({
      commit
    }, stepValue): void {
      commit('setStep3RadioButton', stepValue)
    },
    saveStep3Options ({
      commit
    }, stepValue): void {
      commit('setStep3Options', stepValue)
    },
    saveSurface ({
      commit
    }, stepValue): void {
      commit('setStep3Surface', stepValue)
    },
    saveStep4 ({
      commit
    }, stepValue): void {
      commit('setStep4', stepValue)
    },
    saveStep4Departement ({
      commit
    }, stepValue): void {
      commit('setStep4Departement', stepValue)
    },
    saveStep5 ({
      commit
    }, stepValue): void {
      commit('setStep5', stepValue)
    },
    saveStep6 ({
      commit
    }, stepValue): void {
      commit('setStep6', stepValue)
    }
  },
  modules: {}
})
